/* eslint-disable react/prop-types */
/* eslint-disable radix */
/* eslint-disable prefer-const */
import React from 'react';

import { Checkbox, FormControlLabel, FormGroup } from '@mui/material';

import { ButtonLink } from './styles';
import { ConfigCard } from '../../../../shared/components/ConfigCard';
import { CustomCardContent } from '../DevolutionPreferences/styles';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import useGlobalStore from '../../../../shared/store/globalStore';

export default function ReturnReasons({
  returnReasons,
  setOpenCreateReturnReasonDialog,
}) {
  const removeReturnReason = useGlobalStore(
    (state) => state.configurationRules.removeReturnReason,
  );
  const toggleReturnReason = useGlobalStore(
    (state) => state.configurationRules.toggleReturnReasonSelection,
  );

  return (
    <ConfigCard
      title="Motivos das devoluções"
      trallingIcon={
        <ButtonLink
          type="button"
          onClick={() => setOpenCreateReturnReasonDialog(true)}
        >
          +Adicionar novo motivo
        </ButtonLink>
      }
      justifyContent="flex-start"
      flexWrap="wrap"
    >
      {returnReasons &&
        returnReasons.map((reason, index) => {
          return (
            <CustomCardContent>
              <FormGroup
                sx={{
                  display: 'flex',
                  flexDirection: 'row',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                }}
              >
                <FormControlLabel
                  key={index}
                  control={<Checkbox checked={reason.isSelected} />}
                  label={reason.description}
                  onChange={() => toggleReturnReason(reason.id)}
                />
                <DeleteForeverIcon
                  key={index}
                  sx={{ color: 'var(--color-red)', cursor: 'pointer' }}
                  onClick={(e) => {
                    e.preventDefault();
                    removeReturnReason(reason.id);
                  }}
                />
              </FormGroup>
            </CustomCardContent>
          );
        })}
    </ConfigCard>
  );
}
